"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Karton = void 0;
const echain_shared_oo_1 = require("@igus/echain-shared-oo");
const echain_shared_quantities_1 = require("@igus/echain-shared-quantities");
const echain_shared_validation_1 = require("@igus/echain-shared-validation");
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
const Verpackung_1 = require("./Verpackung");
const echain_product_models_1 = require("@igus/echain-product-models");
/**
 * The class `Karton` is a Value Object representing an igus Karton article.
 */
class Karton extends Verpackung_1.Verpackung {
    constructor() {
        super(...arguments);
        this.className = 'Karton';
    }
    get laenge() {
        return echain_shared_quantities_1.Q.optional(this.model.Laenge);
    }
    set laenge(value) {
        this.model.Laenge = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get breite() {
        return echain_shared_quantities_1.Q.optional(this.model.Breite);
    }
    set breite(value) {
        this.model.Breite = value === null || value === void 0 ? void 0 : value.quantity;
    }
    static fromScratch() {
        return new Karton({
            ArticleType: echain_product_models_1.ArticleType.verpackung,
            Typ: echain_shared_articles_1.VerpackungType.karton,
            EntityId: echain_shared_oo_1.UUIDGenerator.new(),
        });
    }
    static fromExistingArtNr(args, cloneStrategy = 'deep') {
        const msg = 'Karton.fromExistingArtNr: ';
        echain_shared_validation_1.Validation.throws([
            echain_shared_validation_1.Validator.definedNotNull(args.Id, msg + 'Id: '),
            echain_shared_validation_1.Validator.truthy(args.ArtNr || args.ArtNrGenerated, msg + 'ArtNr || ArtNrGenerated: '),
        ]);
        const karton = Karton.fromJson(args, cloneStrategy);
        karton.artNrExists = true;
        return karton;
    }
    static fromInventedArtNr(args, cloneStrategy = 'deep') {
        const msg = 'Karton.fromInventedArtNr: ';
        echain_shared_validation_1.Validation.throws([echain_shared_validation_1.Validator.truthy(args.ArtNr || args.ArtNrGenerated, msg + 'ArtNr || ArtNrGenerated: ')]);
        const karton = Karton.fromJson(args, cloneStrategy);
        karton.artNrExists = false;
        return karton;
    }
    static fromJson(args, cloneStrategy = 'deep') {
        const karton = Karton.fromScratch();
        karton.fromJson(args, cloneStrategy);
        return karton;
    }
    static fromModel(model) {
        const karton = Karton.fromScratch();
        Object.assign(karton.model, model);
        Object.assign(model, karton.model);
        karton.model = model;
        return karton;
    }
    clone() {
        return this._clone(Karton.fromScratch());
    }
    duplicate() {
        return this._duplicate();
    }
    /**
     * Returns the maximal length of a Verpackung or undefined if the maximal length couldn't be
     * calculated.
     */
    getMaxLength() {
        let maxLength;
        if (this.breite && (!maxLength || maxLength.mm < this.breite.mm)) {
            maxLength = this.breite.clone();
        }
        if (this.laenge && (!maxLength || maxLength.mm < this.laenge.mm)) {
            maxLength = this.laenge.clone();
        }
        return maxLength;
    }
    /**
     * Returns the volume of a Verpackung or undefined if the volume couldn't be calculated.
     */
    getVolume() {
        return undefined;
    }
}
exports.Karton = Karton;
//# sourceMappingURL=Karton.js.map